import { cn } from "@/lib/utils";

function Heading({ as, children, className, ...props }) {
  if (as === "h1")
    return (
      <h1
        className={cn(
          "scroll-m-20 text-4xl font-extrabold tracking-tight lg:text-5xl",
          className
        )}
        {...props}
      >
        {children}
      </h1>
    );
  else if (as === "h2")
    return (
      <h2
        className={cn(
          "scroll-m-20  pb-2 text-3xl font-semibold tracking-tight first:mt-0",
          className
        )}
        {...props}
      >
        {children}
      </h2>
    );
  else if (as === "h3")
    return (
      <h3
        className={cn(
          "scroll-m-20 text-2xl font-semibold tracking-tight",
          className
        )}
        {...props}
      >
        {children}
      </h3>
    );
  else if (as === "h4")
    return (
      <h4
        className={cn(
          "scroll-m-20 text-xl font-semibold tracking-tight",
          className
        )}
        {...props}
      >
        {children}
      </h4>
    );
}

export default Heading;
